// src/tonConnectUI.js
import { TonConnectUI } from '@tonconnect/ui-react'

export const tonConnectUI = new TonConnectUI({
	manifestUrl: 'https://fuckmetest.netlify.app/tonconnect-manifest.json',
})
